<script>
export default {
  name: 'MsRouterView',
}
</script>

<template>
  <router-view />
</template>

<style scoped>

</style>
